import React from 'react';
import ListToolbar from 'components/UI/ListToolbar';
import TasksList from './TasksList';

const TasksViewer = ({
  actions,
  onAddTask,
  onSelectAllTasks,
  onTaskClick,
  onTaskSelect,
  projectId,
  selectedTasks,
  taskDefaults,
  tasks,
}) => (
  <>
    {
      actions && (
        <ListToolbar>
          {actions}
        </ListToolbar>
      )
    }
    {
      tasks && (
        <TasksList
          onAddTask={onAddTask}
          onSelectAllTasks={onSelectAllTasks}
          onTaskClick={onTaskClick}
          onTaskSelect={onTaskSelect}
          projectId={projectId}
          selectedTasks={selectedTasks}
          taskDefaults={taskDefaults}
          tasks={tasks}
        />
      )
    }
  </>
);

export default TasksViewer;
